import React from 'react';
import { connect } from 'react-redux';

import {
  setMenu,
  setStyle,
  setTextColor,
  setTextHoverColor,
  setAccentColor,
} from '../actions/navigation-element-actions';

import styles from '../../../../stylesheet/css/header-builder/navigation-element-options.css';

function renderPreviewMenuItem(options, text) {
  const {
    textColor,
    textHoverColor,
    accentColor,
  } = options;

  const onMouseEnter = e => {
    e.currentTarget.querySelector(`.${styles.accent}`).style.backgroundColor = accentColor;
    e.currentTarget.querySelector(`.${styles.text}`).style.color = textHoverColor;
  };

  const onMouseLeave = e => {
    e.currentTarget.querySelector(`.${styles.accent}`).style.backgroundColor = 'transparent';
    e.currentTarget.querySelector(`.${styles.text}`).style.color = textColor;
  };

  return (
    <div className={styles.menuItem}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.accent}></div>
      <div className={styles.text}
        style={{
          color: textColor
        }}
      >
        {text}
      </div>
    </div>
  );
}

export const NavigationElementOptions = ({
  onMenuChange,
  onStyleChange,
  onTextColorChange,
  onTextHoverColorChange,
  onAccentColorChange,
  options = {}
}) => {
  const {
    menu,
    menus = [],
    style,
    styles = [],
    textColor,
    textHoverColor,
    accentColor
  } = options;

  const handleMenuChange = e => onMenuChange(e.target.value);
  const handleStyleChange = e => onStyleChange(e.target.value);
  const handleTextColorChange = e => onTextColorChange(e.target.value);
  const handleTextHoverColorChange = e => onTextHoverColorChange(e.target.value);
  const handleAccentColorChange = e => onAccentColorChange(e.target.value);

  return (
    <div>
      <header>Select Menu:</header>
      <select value={menu} onChange={handleMenuChange}>
        {menus.map(m => <option key={m.value} value={m.value}>{m.text}</option>)}
      </select>

      <header>Navigation Style:</header>
      <select value={style} onChange={handleStyleChange}>
        {styles.map(s => <option key={s.value} value={s.value}>{s.text}</option>)}
      </select>

      <header>Text Color:</header>
      <input type="color" value={textColor} onChange={handleTextColorChange} />

      <header>Text Hover Color:</header>
      <input type="color" value={textHoverColor} onChange={handleTextHoverColorChange} />

      <header>Accent Color:</header>
      <input type="color" value={accentColor} onChange={handleAccentColorChange} />

      <header>Preview:</header>
      <div className={`${styles.preview} ${style}`}>
        {renderPreviewMenuItem(options, 'Home')}
        {renderPreviewMenuItem(options, 'Blog')}
        {renderPreviewMenuItem(options, 'Portfolio')}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onMenuChange(value) {
      dispatch(setMenu({ device, id, value }));
    },

    onStyleChange(value) {
      dispatch(setStyle({ device, id, value }));
    },

    onTextColorChange(value) {
      dispatch(setTextColor({ device, id, value }));
    },

    onTextHoverColorChange(value) {
      dispatch(setTextHoverColor({ device, id, value }));
    },

    onAccentColorChange(value) {
      dispatch(setAccentColor({ device, id, value }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(NavigationElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/NavigationElementOptions.js